import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guardian',
  templateUrl: './guardian.component.html',
  styleUrls: ['./guardian.component.scss'],
  standalone: true,
})
export class GuardianComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
